import { BillingCity, BillingResponse } from '@billing/entities/billing.payload';
import { BillingResponseState } from '@billing/store/reducers/billing-info.reducer';

export const billingFeatureName = 'billingModule';

export type UiBillingState = Readonly<{
  createBilling: boolean,
  lastBilling: boolean
}>;

export type BillingState = Readonly<{
  billingInfo: BillingResponseState,
  cities: BillingCity[],
  defaultBilling: BillingResponse,
  ui: UiBillingState
}>;
